import { emptyTransactionsList, removeTransactionsFilter } from '../../../reducers/actions/customer.transactions.actions';
export var STATE_OR_NAME = 'index.customercare.customer.transactions';
export var LIST_STATE_OR_NAME = 'index.customercare.customer.transactions.list';
export var TRANSACTION_DETAILS_STATE = "".concat(STATE_OR_NAME, ".details");
export default (function ($stateProvider) {
  $stateProvider.state(STATE_OR_NAME, {
    url: '/transactions',
    redirectTo: "".concat(STATE_OR_NAME, ".list"),
    template: '<ui-view class="u-flexKeepHeight"></ui-view>',
    params: {
      previousRoute: null,
      subscription: null,
      selectedPaymentId: null
    },
    onExit: function onExit($ngRedux) {
      $ngRedux.dispatch(removeTransactionsFilter());
      $ngRedux.dispatch(emptyTransactionsList());
    }
  }).state("".concat(STATE_OR_NAME, ".list"), {
    url: '/list?{paymentInstrumentId}{setPaymentFailureFilter}{lockerItemId}{productName}',
    params: {
      fromTransactionSearch: false,
      paymentInstrumentId: null
    },
    template: '<transactions-list></transactions-list>'
  }).state(TRANSACTION_DETAILS_STATE, {
    url: '/:transactionId?{orderId}',
    template: '<transaction-details></transaction-details>'
  });
});